var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',_vm._g({staticClass:"__create",attrs:{"round":""}},_vm.$listeners),[_c('base-icon',[_vm._v("sci-round-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }